import { useNavigate } from 'react-router-dom'

export default function Home() {
  const navigate = useNavigate()

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif", background: '#f8f9fb', color: '#111827', minHeight: '100vh', overflowX: 'hidden' }}>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap" rel="stylesheet" />

      {/* Nav */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, padding: '0 2rem', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(248,249,251,0.9)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #e5e7eb' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 28, height: 28, borderRadius: 8, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 10L5 7L7 9L10 5L12 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
          <span style={{ fontWeight: 700, fontSize: 16, letterSpacing: -0.3, color: '#111827' }}>Complete PT</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => navigate('/login')} style={{ background: 'transparent', color: '#6b7280', border: 'none', fontSize: 14, fontWeight: 500, cursor: 'pointer', padding: '8px 16px', borderRadius: 8, fontFamily: 'inherit' }}>
            Sign in
          </button>
          <button onClick={() => navigate('/signup/clinician')} style={{ background: '#6366f1', color: 'white', border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer', padding: '8px 18px', borderRadius: 8, fontFamily: 'inherit' }}>
            Start free trial
          </button>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ paddingTop: 120, paddingBottom: 80, textAlign: 'center', maxWidth: 800, margin: '0 auto', padding: '140px 2rem 80px' }}>

        <h1 style={{ fontFamily: "'Lora', Georgia, serif", fontSize: 'clamp(36px, 6vw, 68px)', fontWeight: 600, lineHeight: 1.1, letterSpacing: -1.5, margin: '0 0 24px', color: '#111827' }}>
          Home exercise programs<br />
          <span style={{ color: '#6366f1', fontStyle: 'italic' }}>patients actually follow.</span>
        </h1>
        <p style={{ fontSize: 'clamp(16px, 2vw, 20px)', color: '#6b7280', lineHeight: 1.7, maxWidth: 540, margin: '0 auto 40px', fontWeight: 400 }}>
          Complete PT gives clinicians real-time visibility into patient compliance, and gives patients a simple daily checklist they can actually use.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => navigate('/signup/clinician')} style={{ background: '#6366f1', color: 'white', border: 'none', fontSize: 16, fontWeight: 600, cursor: 'pointer', padding: '14px 32px', borderRadius: 10, fontFamily: 'inherit' }}>
            Start 14-day free trial
          </button>
          <button onClick={() => navigate('/login')} style={{ background: 'white', color: '#374151', border: '1px solid #e5e7eb', fontSize: 16, fontWeight: 500, cursor: 'pointer', padding: '14px 32px', borderRadius: 10, fontFamily: 'inherit' }}>
            Sign in
          </button>
        </div>
        <p style={{ marginTop: 16, fontSize: 13, color: '#9ca3af' }}>No credit card required · $19.99/clinician/month after trial</p>
      </section>

      {/* Stats */}
      <section style={{ background: 'white', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb', padding: '48px 2rem' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 32, textAlign: 'center' }}>
          {[
            { stat: '50-70%', label: 'of patients do not complete home exercise programs' },
            { stat: 'Real-time', label: 'compliance visibility for your entire clinic' },
            { stat: 'Unlimited Patients', label: 'no fees per patient, ever.' }
          ].map((item, i) => (
            <div key={i}>
              <div style={{ fontFamily: "'Lora', serif", fontSize: 36, fontWeight: 600, color: '#6366f1', marginBottom: 8, letterSpacing: -1, whiteSpace: 'nowrap' }}>{item.stat}</div>
              <div style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.5 }}>{item.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* How it works */}
      <section style={{ padding: '80px 2rem', maxWidth: 1000, margin: '0 auto' }}>
        <p style={{ fontSize: 11, fontWeight: 700, color: '#6366f1', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 12, textAlign: 'center' }}>How it works</p>
        <h2 style={{ fontFamily: "'Lora', serif", fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 600, textAlign: 'center', margin: '0 0 60px', color: '#111827', letterSpacing: -0.5 }}>Up and running in minutes</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
          {[
            { step: '01', title: 'Build your library', body: 'Upload exercises with photos and instructions. Create diagnosis-based program templates.' },
            { step: '02', title: 'Assign and invite', body: 'Select a patient, apply a program, and send them a magic link. They are in the app in seconds.' },
            { step: '03', title: 'Track in real time', body: 'Patients check off exercises daily. You see compliance per patient and across your whole clinic, updated live throughout the day.' }
          ].map((item, i) => (
            <div key={i} style={{ padding: '32px', background: 'white', border: '1px solid #e5e7eb', borderRadius: 12 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#6366f1', letterSpacing: 2, display: 'block', marginBottom: 16 }}>{item.step}</span>
              <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#111827', letterSpacing: -0.2 }}>{item.title}</h3>
              <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: 14, margin: 0 }}>{item.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '0 2rem 80px', maxWidth: 1000, margin: '0 auto' }}>
        <p style={{ fontSize: 11, fontWeight: 700, color: '#6366f1', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 12, textAlign: 'center' }}>Features</p>
        <h2 style={{ fontFamily: "'Lora', serif", fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 600, textAlign: 'center', margin: '0 0 60px', color: '#111827', letterSpacing: -0.5 }}>Everything your clinic needs</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
          {[
            { icon: '📊', title: 'Live compliance dashboard', body: 'See completion status for every patient today alongside their 30-day compliance rate. Know who to follow up with before they come in.' },
            { icon: '📋', title: 'Program templates', body: 'Build reusable programs by diagnosis. Apply a complete exercise protocol in seconds and customise sets, reps, and schedule per patient.' },
            { icon: '✅', title: 'Exercises and tasks', body: 'Assign graded exercise programs alongside tasks like ice therapy or breathing exercises, each tracked independently.' },
            { icon: '📧', title: 'Magic link invites', body: 'Invite patients by name and email. They set a password and see their program immediately — no app store or invite code needed.' },
            { icon: '🖨️', title: 'Printable HEP', body: 'Patients can export a clean printable home exercise program with photos, instructions, and a weekly schedule grid.' },
            { icon: '🏥', title: 'Multi-clinician support', body: 'Invite colleagues to your clinic. One subscription covers the whole team, billed per clinician seat with no patient limits.' }
          ].map((f, i) => (
            <div key={i} style={{ padding: '28px', background: 'white', border: '1px solid #e5e7eb', borderRadius: 12 }}>
              <div style={{ fontSize: 28, marginBottom: 14 }}>{f.icon}</div>
              <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#111827', letterSpacing: -0.2 }}>{f.title}</h3>
              <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: 14, margin: 0 }}>{f.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      <section style={{ background: 'white', borderTop: '1px solid #e5e7eb', padding: '80px 2rem' }}>
        <div style={{ maxWidth: 520, margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: '#6366f1', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 12 }}>Pricing</p>
          <h2 style={{ fontFamily: "'Lora', serif", fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 600, margin: '0 0 12px', color: '#111827', letterSpacing: -0.5 }}>Simple, transparent pricing</h2>
          <p style={{ color: '#6b7280', marginBottom: 48, fontSize: 16 }}>One plan. No feature tiers. No per-patient fees.</p>
          <div style={{ background: '#f8f9fb', border: '1px solid #e5e7eb', borderRadius: 16, padding: '40px' }}>
            <div style={{ marginBottom: 28 }}>
              <span style={{ fontSize: 52, fontWeight: 800, letterSpacing: -2, color: '#111827' }}>$19.99</span>
              <span style={{ fontSize: 16, color: '#9ca3af', marginLeft: 4 }}>/clinician/month</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 32, textAlign: 'left' }}>
              {[
                'Unlimited patients',
                'Full exercise and task library',
                'Real-time compliance dashboard',
                'Program templates by diagnosis',
                'Magic link patient invites',
                'Printable home exercise programs',
                '14-day free trial, no card required'
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1.5 4L3.5 6L6.5 2" stroke="#6366f1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                  <span style={{ fontSize: 14, color: '#374151' }}>{item}</span>
                </div>
              ))}
            </div>
            <button onClick={() => navigate('/signup/clinician')} style={{ width: '100%', background: '#6366f1', color: 'white', border: 'none', fontSize: 16, fontWeight: 600, cursor: 'pointer', padding: '14px', borderRadius: 10, fontFamily: 'inherit' }}>
              Start your free trial
            </button>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '80px 2rem', textAlign: 'center', background: 'linear-gradient(135deg, #6366f1, #4f46e5)' }}>
        <h2 style={{ fontFamily: "'Lora', serif", fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 600, margin: '0 0 16px', color: 'white', letterSpacing: -0.5 }}>
          Ready to close the loop?
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 18, marginBottom: 36, fontWeight: 300 }}>
          Set up your clinic in under 10 minutes.
        </p>
        <button onClick={() => navigate('/signup/clinician')} style={{ background: 'white', color: '#6366f1', border: 'none', fontSize: 16, fontWeight: 700, cursor: 'pointer', padding: '14px 36px', borderRadius: 10, fontFamily: 'inherit' }}>
          Get started free
        </button>
      </section>

      {/* Footer */}
      <footer style={{ background: '#111827', padding: '32px 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
        <span style={{ fontSize: 13, color: '#6b7280' }}>2026 Complete PT</span>
        <div style={{ display: 'flex', gap: 24 }}>
          <a href="/privacy" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}>Privacy</a>
          
          <a href="mailto:sales@completept.app" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}>Contact</a>
          <a href="mailto:support@completept.app" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}>Support</a>
        </div>
      </footer>
    </div>
  )
}